import { withStyles, FormControlLabel } from "@material-ui/core";

export const FormControlWrapper = withStyles(() => ({
  root: {
    marginLeft: "0px"
  }
}))(FormControlLabel);